<template>
    <div>
        <!--下拉菜单开始  -->

        <!--头部开始 -->
        <div class="g-top hidden-print">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 m-top">
                        <div class="pull-left top-con">
                            <a href="http://www.gov.cn" target="_blank"
                            >中央人民政府门户网站</a
                            >
                            <a href="http://www.shaanxi.gov.cn" target="_blank"
                            >陕西省人民政府</a
                            >
                        </div>
                        <div class="pull-right top-con text-right hidden-xs">
                            <a href="http://www.hanzhong.gov.cn/shuangcheng/"
                               style="background: rgb(143, 193, 216);padding: 3px 20px;color: #fff;border-radius: 2rem;">双城联动</a>
                            <a class="hidden-xs" href="http://www.xa.gov.cn/index/gywm/60e2b28ef8fd1c0bdc37e204.html">市政府网站APP</a>
                            <a
                                    href="http://xianzf.intertid.com"
                                    class="hidden-xs"
                                    target="_blank"
                            >无障碍</a
                            >
                            <a href="http://en.xa.gov.cn" target="_blank">ENGLISH</a>
                            <a href="http://kr.xa.gov.cn" target="_blank">한국어</a>
                            <a href="http://mail.xa.gov.cn" target="_blank">邮箱</a>

                            <a
                                    class="icon-wza hidden-xs"
                                    id="StranLink"
                                    name="StranLink"
                                    style="cursor:pointer;"
                                    @click="fan(name)"
                                    :title="'点击以'+name+'体中文方式浏览'"
                            >{{name}}</a
                            >
                          <a v-if="orderType1"
                             @click="logout"
                          >退出</a
                          >
                            <a
                                    v-else
                                    class="hidden-xs"
                                    id="btndl"
                                    style="cursor:pointer;"
                                    @click="getSignUrl"
                                    siteid="10039"
                            >登录</a
                            >
                            <a
                                    target="_blank"
                                    href="https://sfrz.shaanxi.gov.cn/sysauth-v3/index/register?client_id=000000000&amp;redirect_uri=null&amp;loginflg=0&amp;pass_ok=true"
                            >注册</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--头部结束 -->
        <!--导航开始 -->
        <div class="header-bd">
            <div class="container">
                <div class="row clearfix">
                    <div class="navbar">
                        <div class="navbar-header">
                            <a href="/">
                                <img src="@/assets/images/logo.png"/>
                            </a>

                            <el-dropdown trigger="click" @command="handleCommand">
                                <el-button
                                        class="mobile-menu"
                                        icon="el-icon-menu"
                                ></el-button>
                                <el-dropdown-menu slot="dropdown" style="width:100%;height:76%" split-button>
                                    <el-dropdown-item class="custom-item" command="0">首页</el-dropdown-item>
                                    <!-- <el-dropdown-item class="custom-item" command="1">领导</el-dropdown-item> -->
                                    <el-dropdown-item class="custom-item" command="2">新闻</el-dropdown-item>
                                    <el-dropdown-item class="custom-item" command="3">公开</el-dropdown-item>
                                    <el-dropdown-item class="custom-item" command="4">服务</el-dropdown-item>
                                    <el-dropdown-item class="custom-item" command="5">互动</el-dropdown-item>
                                    <el-dropdown-item class="custom-item" command="6">市情</el-dropdown-item>
                                    <el-dropdown-item class="custom-item" command="7">数据</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <ul class="nav navbar-nav hidden-xs" v-if="!showSearch">
                            <li><a href="http://www.xa.gov.cn/" target="_blank">首页</a></li>
                            <!-- <li>
                                <a href="http://www.xa.gov.cn/ld/lmy/" target="_blank">领导</a>
                            </li> -->
                            <li>
                                <a href="http://www.xa.gov.cn/xw/" target="_blank">新闻</a>
                            </li>
                            <li>
                                <a href="http://www.xa.gov.cn/gk/" target="_blank">公开</a>
                            </li>
                            <li>
                                <a
                                        target="_blank"
                                        href="http://zwfw.xa.gov.cn/zdpyc/door/#/home/home-new-index?areaCode=610100000000"
                                >服务</a
                                >
                            </li>
                            <li>
                                <a target="_blank" href="http://www.xa.gov.cn/hd/">互动</a>
                            </li>
                            <li>
                                <a target="_blank" href="http://www.xa.gov.cn/sq/">市情</a>
                            </li>
                            <li>
                                <a href="http://tjj.xa.gov.cn/tjsj/1.html" target="_blank"
                                >数据</a
                                >
                            </li>
                        </ul>

                        <div
                                class="search-icon hidden-xs"
                                @click="search"
                                v-if="!showSearch"
                        >
                            搜索
                            <i
                                    slot="suffix"
                                    class="el-icon-search"
                                    style="right: 10px; position: relative; font-size: 20px"
                            ></i>
                        </div>
                        <div class="m-search" v-if="showSearch">
              <span
                      class="icon-moreunfold col-md-2 pull-left sc_sliderdown"
                      style="font-weight: bold"
                      @click="showSearch = false"
              ><i slot="suffix" class="el-icon-arrow-down"></i>
              </span>

                            <el-input
                                    placeholder="请输入搜索关键词"
                                    v-model="input0"
                                    class="elInput"
                            >
                                <i
                                        slot="suffix"
                                        class="el-input__icon el-icon-search"
                                        @click="go"
                                ></i>
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--导航结束 -->
        <!-- 当前位置开始 -->
        <!-- <div class="position">
                <div class="container">
                    <span>
                        <a href="/">首页</a>
                        <span>/</span>
                    </span>
                    <span>
                        <a>互动</a>
                    </span>
                </div>
            </div> -->
        <!-- 当前位置结束 -->
    </div>
</template>
<script>

    import config from "@/config";

    export default {
        data() {
            return {
                showSearch: false,
                input0: "",
                name:'繁',
                orderType1:localStorage.getItem('orderType1')//确认登录
            };
        },
        watch:{
            "$store.state.orderType1"(value){
                this.orderType1 = value;
            }
        },
        methods: {
            fan(name){
                if(name=='繁'){
                    this.zhTran('t')
                    this.name='简'
                }else if(name=='简'){
                    this.zhTran('s')
                    this.name='繁'
                }

            },
            search() {
                this.showSearch = true;
            },
            go() {
                window.open("http://www.xa.gov.cn/so/s?qt=" + this.input0);
            },
            handleCommand(type) {
                let href = "";
                switch (type) {
                    case "0":
                        href = "http://www.xa.gov.cn/"
                        break;
                    case "1":
                        href = "http://www.xa.gov.cn/ld/lmy/"
                        break;
                    case "2":
                        href = "http://www.xa.gov.cn/xw/"
                        break;
                    case "3":
                        href = "http://www.xa.gov.cn/gk/"
                        break;
                    case "4":
                        href = "http://zwfw.xa.gov.cn/zdpyc/door/#/home/home-new-index?areaCode=610100000000"
                        break;
                    case "5":
                        href = "http://www.xa.gov.cn/hd/"
                        break;
                    case "6":
                        href = "http://www.xa.gov.cn/sq/"
                        break;
                    case "7":
                        href = "http://tjj.xa.gov.cn/tjsj/1.html"
                        break;
                    default:
                        break;
                }

                console.log(href)
                window.open(href)
            },
            //退出
            logout() {
                this.$confirm('确定退出登录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    
                  let href = window.location.href;
                    let token = localStorage.getItem('token')
                  localStorage.removeItem("callPhone")
                  localStorage.removeItem("name")
                  localStorage.removeItem("orderType1")
                  this.$store.commit('isLogin','')
                  localStorage.clear();
                  window.location.href = config.ssoLogin+'/sysauthserver/logout?access_token='+token+"&client_id="+config.client_id+"&client_secret="+config.clientSecret+"&redirect_uri="+href
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });
                });
            },
        },
    };
</script>
<style scoped>
    @media (min-width: 768px) {
        .container {
            width: 736px;
        }

        .navbar-header {
            float: left;
        }

        .navbar-nav {
            padding: 0 !important;
            display: inline-block;
        }
    }

    @media (min-width: 992px) {
        .container {
            width: 956px;
        }
    }

    @media (min-width: 1200px) {
        .container {
            width: 1216px;
        }
    }

    @media (min-width: 1314px) {
        .container {
            width: 1330px;
        }
    }

    @media screen and (max-width: 1200px) {
        body .navbar {
            height: 125px;
        }
    }

    @media screen and (max-width: 765px) {
        .hidden-xs {
            display: none;
        }

        body .navbar {
            height: 77px;
        }

        body .mobile-menu {
            display: inline;
            float: right;
            margin-top: 16px;
            border-color: #ddd;
            border-radius: 4px;
            font-size: 22px;
            text-align: center;
            padding: 5px;
            width: 44px;
        }
    }

    .mobile-menu {
        display: none;
    }

    .container {
        margin-right: auto;
        margin-left: auto;
        padding-left: 8px;
        padding-right: 8px;
    }

    .g-top {
        width: 100%;
        height: 38px;
        line-height: 38px;
        background: #226ebc;
    }

    .top-con a {
        color: #fff;
        font-size: 14px;
        margin: 0 0.5rem;
    }

    .row {
        margin-left: -8px;
        margin-right: -8px;
    }

    .pull-left {
        float: left !important;
    }

    .m-top .top-con a {
        color: #fff !important;
    }

    .card a:hover,
    a:active,
    a:link,
    a:visited {
        color: #333;
        text-decoration: none;
    }

    .col-lg-12 {
        position: relative;
        min-height: 1px;
        padding-left: 8px;
        padding-right: 8px;
    }

    .pull-right {
        float: right !important;
    }

    .text-right {
        text-align: right;
    }

    /* 导航 */
    .header-bd {
        background: #fff;
        box-shadow: 0 0 9px 0 rgba(84, 126, 168, 0.32);
    }

    .navbar {
        position: relative;
        padding: 25px 11px;
        border: none;
        background: #fff;
        height: 70px;
    }

    .navbar-header {
    }

    .navbar-header img {
        width: 290px;
    }

    .navbar-nav {
        /* float: right; */
        height: 69px;
        margin: 0;
        padding-left: 20px;
        padding-right: 140px;
        line-height: 69px;
    }

    .nav {
        list-style: none;
    }

    .navbar-nav li {
        text-align: center;
    }

    .navbar-nav li {
        width: 80px;
        padding: 0 5px;
        line-height: 69px;
    }

    .nav > li {
        position: relative;
        display: inline-block;
    }

    .navbar-default .navbar-nav > li > a {
        padding: 0;
        line-height: 69px;
        color: #000;
    }

    .navbar-nav li a {
        color: #343434;
        font-size: 20px;
    }

    .search-icon {
        position: absolute;
        top: 40px;
        right: 0;
        height: 36px;
        border: 1px solid #d2d2d2;
        border-radius: 18px;
        line-height: 36px;
        text-align: center;
        color: #8e979c;
        font-weight: 400;
        font-size: 16px;
        cursor: pointer;
        text-indent: 1.5em;
    }

    .search-icon span {
        padding: 0 10px;
        color: #939192;
    }

    .elInput {
        width: 80%;
        height: 42px;
        border: 1px solid #226ebc;
        border-radius: 20px;
        line-height: 42px;
    }

    .sc_sliderdown {
        width: 44px;
        margin-right: 10px;
        border-radius: 50%;
        line-height: 42px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        background: #226ebc;
    }

    .icon-moreunfold {
        font-size: 18px;
    }

    .m-search {
        height: 44px;
        width: 30%;
        margin: 0 auto;
        line-height: 40px;
    }

    .m-search .el-icon-search {
        cursor: pointer;
    }
</style>
<style>
    .elInput .el-input__inner {
        border: none;
        margin-left: 10px;
        width: 90%;
    }

    .custom-item {
        border-bottom: 1px solid #ccc;
        text-align: center;
    }
</style>

